import React, { useState } from "react";
import JobListCard from "../../../components/jobs/JobListCard";
import { useIds } from "../../../hook/AdminContext";
import {
  delete_live_job_feed_api,
  favourite_live_job_api,
  job_reniew_api,
} from "../../../DAL/TalentSourceAPI/TalentSourceApi";
import { enqueueSnackbar } from "notistack";
import CustomConfirmation from "../../../components/popUp/CustomConfirmation";
import UpgradeModal from "../../../components/popUp/UpgradeModal";
import PostJobHeader from "../../post/PostJobHeader";
import CustomPopoverNew from "../../../components/CustomPopoverNew";
import SharePostPopup from "../../../components/cards/SharePostPopup";
import CustomModalLayout from "../../../components/modal/CustomModalLayout";
import { useNavigate } from "react-router-dom";

export default function ClientsJobCard({
  job,
  isTablet,
  setListing,
  fetchDetails = () => {},
  setJobsList = () => {},
  handleMoveJobCandidates = () => {},
  handleMoveJobDetails = () => {},
}) {
  const { userInfo, handleReportPost } = useIds();
  const [openEditModal, setOpenEditModal] = useState(false);
  const navigate = useNavigate();
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const [openRenewConfirm, setOpenRenewConfirm] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  // share job State
  const [openSharePost, setOpenSharePost] = useState(null);

  const handleOpenEditJob = () => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    // setOpenEditModal(true);
    navigate(`/${job.source.slug}/edit-job/${job.job_slug}`, {
      state: { job },
    });
  };

  // share post state and functions
  const handleOpenSharePost = () => {
    setOpenSharePost(true);
  };

  const handleDeleteMember = async () => {
    // ID as parameter lein
    const response = await delete_live_job_feed_api(job.job_slug);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      handleFilterJob(job._id);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteDialogOpen(false);
  };

  const handleDelete = (row) => {
    setDeleteDialogOpen(true);
  };

  const handleRenewJob = async () => {
    const response = await job_reniew_api(job._id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setListing((prev) =>
        prev.map((obj) =>
          obj._id === job._id
            ? {
                ...obj,
                renewalStatus: {
                  ...obj.renewalStatus,
                  canRenew: false,
                },
              }
            : obj
        )
      );
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setOpenRenewConfirm(false);
  };
  const handleRenewClick = () => {
    setOpenRenewConfirm(true);
  };

  const handleNavigateReportJob = () => {
    handleReportPost(job, "job", handleFilterJob);
  };

  const handleFilterJob = (id) => {
    setListing((prev) => prev.filter((item) => item._id !== id));
    fetchDetails();
  };

  const getRenewalStatus = (row) => {
    if (!row?.next_renewal_date) return false;
    if (row?.renewalStatus?.canRenew == false) return false;

    const renewalDate = new Date(row.next_renewal_date);
    const now = new Date();

    return renewalDate <= now; // true if arrived/passed, false otherwise
  };

  const handleBookmarkToggle = () => {
    let newBookmarkedState = true;
    setListing((prev) => {
      return prev.map((obj) => {
        if (obj._id === job._id) {
          newBookmarkedState = !job.is_favourite;
          return { ...obj, is_favourite: !job.is_favourite };
        }
        return obj;
      });
    });

    let postData = { job_id: job._id };

    favourite_live_job_api(postData)
      .then((response) => {
        // Check if the API returns a specific message
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  const MENU_OPTIONS = (job) => {
    if (job?.created_by?._id === userInfo?.profile_id) {
      let optionsArray = [];

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        });
      }

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Renew Job",
          icon: "mdi:refresh",
          handleClick: (row) => {
            handleRenewClick(row._id);
          },
          isRefresh: true,
          getDisabled: (row) => !getRenewalStatus(row), // Disable if can't renew
          getTooltip: (row) =>
            !getRenewalStatus(row)
              ? "You can only renew this job after 7 days of posting."
              : "",
        });
      }

      optionsArray.push({
        label: "Share Job",
        icon: "mdi:share-outline",
        handleClick: () => {
          handleOpenSharePost();
        },
      });

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.delete &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
        });
      }

      return optionsArray;
    } else {
      return [
        {
          label: "Share Job",
          icon: "mdi:share-outline",
          handleClick: () => {
            handleOpenSharePost();
          },
        },
        {
          label: "Report Job",
          icon: "material-symbols:report-outline",
          handleClick: (row, index) => handleNavigateReportJob(row),
          color: "error",
        },
      ];
    }
  };

  return (
    <>
      {openRenewConfirm && (
        <CustomConfirmation
          open={openRenewConfirm}
          setOpen={setOpenRenewConfirm}
          headerHeading="Renew Job"
          title="Are you sure you want to renew this job?"
          handleAgree={() => {
            handleRenewJob();
          }}
        />
      )}

      {deleteDialogOpen && (
        <CustomConfirmation
          openDelete={deleteDialogOpen}
          setOpenDelete={setDeleteDialogOpen}
          headerHeading="Delete Job"
          title={"Are you sure you want to delete this job?"}
          handleAgree={() => handleDeleteMember()}
        />
      )}
      {openUpgradeModal && (
        <UpgradeModal
          open={openUpgradeModal}
          handleClose={() => setOpenUpgradeModal(false)}
        />
      )}

      <CustomModalLayout
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
        }}
        title={"Update Job"}
        width="850px"
        componentToPass={
          <PostJobHeader
            refreshlist={() => {}}
            open={openEditModal}
            handleClose={() => {
              setOpenEditModal(false);
            }}
            editMode={true}
            jobData={job}
            sourceSLug={job?.source?.slug || ""}
          />
        }
      />

      {openSharePost && (
        <CustomModalLayout
          open={openSharePost}
          onClose={() => setOpenSharePost(false)}
          title="Share Job"
          width="550px"
          componentToPass={
            <SharePostPopup
              postData={{
                ...job,
                _id: job.job_slug,
                description: job.job_title,
              }}
              type={"job"}
            />
          }
        />
      )}

      <JobListCard
        job={job}
        fetchDetails={fetchDetails}
        setJobsList={setJobsList}
        handleCompanyNameClick={() => {}}
        handlePageMove={(job) => {
          handleMoveJobDetails(job);
        }}
        handleCandidates={(job) => {
          handleMoveJobCandidates(job);
        }}
        isTablet={isTablet}
        MENU_OPTIONS={MENU_OPTIONS}
        handleBookmarkToggle={handleBookmarkToggle}
        isDetailClient={true}
      />
    </>
  );
}
